(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bf-brand-engraving-faq"] && !Shopify.designMode) return;
  try {
    
  function initEngraving(root) { root.querySelectorAll('[data-bf-engraving-gallery]').forEach(function(gallery) {
    if (gallery.dataset.initialized) return;
    gallery.dataset.initialized = 'true';
    const track = gallery.querySelector('[data-bf-engraving-track]');
    const slides = Array.from(track.querySelectorAll('.bf-engraving-gallery__slide'));
    const dots = Array.from(gallery.querySelectorAll('.bf-engraving-gallery__dots span'));
    let current = 0;

    function show(index) {
      current = (index + slides.length) % slides.length;
      track.scrollTo({
        left: slides[current].offsetLeft,
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
      dots.forEach(function(dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === current);
      });
    }

    gallery.addEventListener('click', function(event) {
      const button = event.target.closest('[data-bf-engraving-prev], [data-bf-engraving-next]');
      if (!button) return;
      const direction = button.hasAttribute('data-bf-engraving-next') ? 1 : -1;
      show(current + direction);
    });

    track.addEventListener('scroll', function() {
      const index = slides.reduce(function(closest, slide, slideIndex) {
        return Math.abs(slide.offsetLeft - track.scrollLeft) < Math.abs(slides[closest].offsetLeft - track.scrollLeft) ? slideIndex : closest;
      }, 0);
      current = index;
      dots.forEach(function(dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === index);
      });
    });
  });
  }
  initEngraving(document);
  document.addEventListener('shopify:section:load', event => initEngraving(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-curated-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  const instances = new WeakMap();
  function init(section) {
    if (instances.has(section)) return;
    const abort = new AbortController();
    const on = (el, type, handler, options = {}) => el?.addEventListener(type, handler, { ...options, signal: abort.signal });
    const track = section.querySelector('[data-bf-reviews-track]');
    const slides = Array.from(section.querySelectorAll('[data-bf-review-slide]'));
    const dots = Array.from(section.querySelectorAll('.bf-curated-reviews__dots span'));
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    let trackWidth = track.clientWidth;
    let current = 0, timer, paused = motion.matches, visible = false, hovering = false;
    function fit() {
      if (!slides[current]) return;
      track.style.height = slides[current].offsetHeight + 'px';
      dots.forEach((dot, index) => dot.classList.toggle('is-active', index === current));
      slides.forEach(slide => {
        const quote = slide.querySelector('blockquote');
        const more = slide.querySelector('[data-bf-review-more]');
        more.hidden = !slide.classList.contains('is-expanded') && quote.scrollHeight <= quote.clientHeight + 1;
      });
    }
    function schedule() {
      clearTimeout(timer);
      if (paused || !visible || document.hidden || hovering || section.contains(document.activeElement) || slides.length < 2) return;
      timer = setTimeout(() => { show(current + 1); schedule(); }, 7000);
    }
    function pause() { paused = true; schedule(); }
    function show(index) {
      current = (index + slides.length) % slides.length;
      track.scrollTo({ left: slides[current].offsetLeft, behavior: motion.matches ? 'instant' : 'smooth' });
      fit();
    }
    on(section.querySelector('[data-bf-reviews-prev]'), 'click', () => { pause(); show(current - 1); });
    on(section.querySelector('[data-bf-reviews-next]'), 'click', () => { pause(); show(current + 1); });
    on(track, 'pointerdown', pause, { passive: true });
    on(track, 'keydown', pause);
    on(track, 'wheel', pause, { passive: true });
    on(track, 'scroll', () => {
      if (track.clientWidth !== trackWidth) return;
      current = slides.reduce((best, slide, i) => Math.abs(slide.offsetLeft - track.scrollLeft) < Math.abs(slides[best].offsetLeft - track.scrollLeft) ? i : best, 0);
      fit();
    }, { passive: true });
    on(window, 'resize', () => {
      trackWidth = track.clientWidth;
      track.scrollTo({ left: slides[current]?.offsetLeft || 0, behavior: 'instant' });
      fit();
    });
    on(section, 'click', event => {
      const button = event.target.closest('[data-bf-review-more]');
      if (!button) return;
      pause();
      const expanded = button.closest('[data-bf-review-slide]').classList.toggle('is-expanded');
      button.setAttribute('aria-expanded', String(expanded));
      button.textContent = expanded ? button.dataset.less : button.dataset.more;
      fit();
    });
    on(section, 'mouseenter', () => { hovering = true; schedule(); });
    on(section, 'mouseleave', () => { hovering = false; schedule(); });
    on(section, 'focusin', schedule);
    on(section, 'focusout', () => setTimeout(schedule, 0));
    on(document, 'visibilitychange', schedule);
    on(motion, 'change', () => { if (motion.matches) paused = true; schedule(); });
    const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; schedule(); }, { threshold: 0.4 });
    observer.observe(section);
    const resize = new ResizeObserver(fit);
    slides.forEach(slide => resize.observe(slide));
    instances.set(section, () => { clearTimeout(timer); observer.disconnect(); resize.disconnect(); abort.abort(); });
    fit();
    schedule();
  }
  function scan(root = document) { root.querySelectorAll('[data-bf-curated-reviews]').forEach(init); }
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-bf-curated-reviews]').forEach(section => { instances.get(section)?.(); instances.delete(section); }));
  scan();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(() => {
  if (window.misakiBFCollection) return;
  window.misakiBFCollection = true;
  const gridSelector = '.bf-collection .collection-grid__wrapper > .grid';
  const pageKey = () => location.pathname + location.search;
  let grid, key, controller, busy = false, restoring = false, changing = false;
  let page = 1, visibleCount = 6, sorted = false, scrollTimer;
  const discountMode = () => new URLSearchParams(location.search).get('bf_sort') === 'discount-descending';
  const offers = () => document.querySelector('#bf-deals');
  const loadLink = () => document.querySelector('[data-bf-load-more-link]');
  const status = () => document.querySelector('[data-bf-load-more-status]');
  const cards = () => Array.from(grid?.children || []);
  const setStatus = message => { if (status()) status().textContent = message; };

  function save() {
    if (!grid?.isConnected || restoring || changing || key !== pageKey()) return;
    const state = { key, page, visibleCount, y: window.scrollY };
    history.replaceState({ ...history.state, misakiBF: state }, '');
  }

  function loading(active) {
    busy = active;
    const link = loadLink();
    if (!link) return;
    const wrapper = link.closest('[data-bf-load-more]');
    link.setAttribute('aria-busy', String(active));
    link.textContent = active ? wrapper.dataset.loadingText : link.dataset.label;
  }

  async function appendPage() {
    const link = loadLink();
    if (!link || !link.hasAttribute('href')) return false;
    const targetGrid = grid;
    const url = new URL(link.href);
    const nextPage = Number(url.searchParams.get('page'));
    if (!nextPage || nextPage <= page) throw new Error('Invalid next page');
    url.searchParams.set('section_id', document.querySelector('.bf-collection').dataset.sectionId);
    const response = await fetch(url.href, { signal: controller.signal });
    if (!response.ok) throw new Error('Page unavailable');
    const nextDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
    const nextGrid = nextDocument.querySelector(gridSelector);
    if (grid !== targetGrid || !targetGrid.isConnected) throw new DOMException('Stale grid', 'AbortError');
    if (!nextGrid) throw new Error('Product grid missing');
    const existing = new Set(cards().map(card => card.dataset.productId));
    Array.from(nextGrid.children).forEach(card => {
      if (!existing.has(card.dataset.productId)) grid.appendChild(document.importNode(card, true));
    });
    page = nextPage;
    const next = nextDocument.querySelector('[data-bf-load-more-link]');
    if (next) link.href = next.getAttribute('href');
    else { link.removeAttribute('href'); link.hidden = true; }
    return true;
  }

  function refreshProducts() {
    window.theme?.reinitProductGridItem?.();
    initGalleries(grid);
    document.dispatchEvent(new CustomEvent('bf:products-appended'));
  }

  function updateGalleryControls(gallery, requestedIndex) {
    if (!gallery) return;
    const imageCount = gallery.children.length;
    const current = requestedIndex ?? Math.round(gallery.scrollLeft / Math.max(gallery.clientWidth, 1));
    const wrapper = gallery.parentElement;
    const previous = wrapper.querySelector('[data-bf-gallery-previous]');
    const next = wrapper.querySelector('[data-bf-gallery-next]');
    if (previous) {
      previous.hidden = current <= 0;
      previous.disabled = current <= 0;
    }
    if (next) {
      next.hidden = current >= imageCount - 1;
      next.disabled = current >= imageCount - 1;
    }
  }

  function initGalleries(scope = document) {
    scope.querySelectorAll('.bf-product-gallery').forEach(gallery => {
      if (!gallery.dataset.bfGalleryReady) {
        gallery.dataset.bfGalleryReady = 'true';
        let frame;
        gallery.addEventListener('scroll', () => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => updateGalleryControls(gallery));
        }, { passive: true });
      }
      updateGalleryControls(gallery);
    });
  }

  function reveal() {
    const all = cards();
    all.forEach((card, index) => { card.hidden = index >= visibleCount; });
    const link = loadLink();
    if (link) { link.hidden = visibleCount >= all.length; link.setAttribute('role', 'button'); link.tabIndex = 0; }
  }

  async function prepareDiscount() {
    const targetGrid = grid;
    loading(true);
    const wrapper = document.querySelector('[data-bf-load-more]');
    const note = document.querySelector('[data-bf-sort-note]');
    if (note) note.hidden = false;
    grid.style.visibility = 'hidden';
    if (wrapper) setStatus(wrapper.dataset.loadingText);
    try {
      while (loadLink()?.hasAttribute('href')) await appendPage();
      cards().sort((a, b) => Number(b.dataset.bfDiscount) - Number(a.dataset.bfDiscount))
        .forEach(card => grid.appendChild(card));
      sorted = true;
      reveal();
      setStatus('');
      refreshProducts();
    } catch (error) {
      if (error.name !== 'AbortError' && wrapper) {
        setStatus(wrapper.dataset.errorText);
        cards().forEach(card => { card.hidden = true; });
        if (loadLink()) loadLink().hidden = false;
      }
    } finally {
      if (grid === targetGrid) { grid.style.visibility = ''; loading(false); }
    }
  }

  async function init() {
    const nextGrid = document.querySelector(gridSelector);
    if (!nextGrid || nextGrid === grid) return;
    controller?.abort();
    grid = nextGrid;
    initGalleries(grid);
    key = pageKey();
    controller = new AbortController();
    changing = false;
    sorted = false;
    page = Number(offers().dataset.bfPage || 1);
    const saved = history.state?.misakiBF;
    const resume = saved?.key === key ? saved : null;
    visibleCount = resume?.visibleCount || cards().length;
    restoring = true;
    const link = loadLink();
    if (link) link.dataset.label = link.textContent.trim();
    const select = document.querySelector('#SortBy');
    if (discountMode() && select) select.value = 'bf-discount';
    try {
      if (discountMode()) await prepareDiscount();
      else {
        if (resume && resume.page > page) {
          loading(true);
          while (page < resume.page && loadLink()?.hasAttribute('href')) await appendPage();
          refreshProducts();
        }
        visibleCount = cards().length;
      }
      if (grid !== nextGrid) return;
      if (resume) window.scrollTo({ top: resume.y, behavior: 'instant' });
    } catch (error) {
      if (error.name !== 'AbortError') setStatus(document.querySelector('[data-bf-load-more]')?.dataset.errorText || '');
    } finally {
      if (grid === nextGrid) { restoring = false; loading(false); save(); }
    }
  }

  document.addEventListener('click', async event => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
    const galleryButton = event.target.closest('[data-bf-gallery-previous], [data-bf-gallery-next]');
    if (galleryButton) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const gallery = galleryButton.parentElement.querySelector('.bf-product-gallery');
      const current = Math.round(gallery.scrollLeft / Math.max(gallery.clientWidth, 1));
      const direction = galleryButton.hasAttribute('data-bf-gallery-previous') ? -1 : 1;
      const targetIndex = Math.min(Math.max(current + direction, 0), gallery.children.length - 1);
      const target = targetIndex * gallery.clientWidth;
      const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
      updateGalleryControls(gallery, targetIndex);
      gallery.scrollTo({ left: target, behavior: reduceMotion ? 'instant' : 'smooth' });
      return;
    }
    const link = event.target.closest('a');
    if (!link) return;
    if (link.getAttribute('href') === '#bf-deals' && offers()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      save();
      history.replaceState(history.state, '', '#bf-deals');
      offers().scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      return;
    }
    if (link.closest('.bf-collection .grid-product')) save();
    if (!link.matches('[data-bf-load-more-link]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy) return;
    const wrapper = link.closest('[data-bf-load-more]');
    if (discountMode()) {
      if (!sorted) await prepareDiscount();
      else { visibleCount += 6; reveal(); }
      save();
      return;
    }
    const targetGrid = grid;
    loading(true);
    setStatus('');
    try {
      const previousCount = cards().length;
      await appendPage();
      visibleCount = cards().length;
      refreshProducts();
      const firstNew = cards()[previousCount];
      firstNew?.querySelector('a')?.focus({ preventScroll: true });
      save();
    } catch (error) {
      if (error.name !== 'AbortError') setStatus(wrapper.dataset.errorText);
    } finally { if (grid === targetGrid) loading(false); }
  }, true);

  document.addEventListener('keydown', event => {
    if (event.target.matches('[data-bf-load-more-link]:not([href])') && ['Enter', ' '].includes(event.key)) { event.preventDefault(); event.target.click(); }
  });

  document.addEventListener('change', event => {
    const select = event.target.closest('.bf-collection #SortBy');
    if (!select) return;
    event.stopImmediatePropagation();
    save();
    const url = new URL(location.href);
    url.searchParams.delete('page');
    if (select.value === 'bf-discount') {
      url.searchParams.set('bf_sort', 'discount-descending');
      url.searchParams.set('sort_by', 'manual');
    } else {
      url.searchParams.delete('bf_sort');
      url.searchParams.set('sort_by', select.value);
    }
    url.hash = 'bf-deals';
    location.assign(url.href);
  }, true);

  document.addEventListener('bf:collection-changing', () => { save(); changing = true; controller?.abort(); });
  document.addEventListener('collection:reloaded', init);
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('scroll', () => { clearTimeout(scrollTimer); scrollTimer = setTimeout(save, 150); }, { passive: true });
  window.addEventListener('resize', () => initGalleries(grid || document), { passive: true });
  window.addEventListener('pagehide', save);
  window.addEventListener('pageshow', event => { if (!event.persisted) init(); });
  window.addEventListener('popstate', () => {
    if (grid && key !== pageKey()) location.reload();
  });
  init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-knife-advisor-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('misaki-knife-advisor')) {
    customElements.define('misaki-knife-advisor', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.dataset.enhanced = 'true';
        this.currentGroup = '';
        this.previousGroup = '';
        this.currentResult = '';

        this.startStage = this.querySelector('[data-stage="start"]');
        this.questionStages = Array.from(this.querySelectorAll('[data-stage="question"]'));
        this.resultStages = Array.from(this.querySelectorAll('[data-stage="result"]'));
        this.progressItems = Array.from(this.querySelectorAll('[data-progress]'));

        this.questionStages.forEach((stage) => { stage.hidden = true; });
        this.resultStages.forEach((stage) => { stage.hidden = true; });

        this.querySelectorAll('[data-advisor-route]').forEach((link) => {
          link.addEventListener('click', (event) => {
            const group = link.dataset.advisorRoute;
            if (!this.querySelector(`[data-question="${group}"]`)) return;
            event.preventDefault();
            this.currentResult = '';
            this.previousGroup = '';
            this.showQuestion(group);
          });
        });

        this.querySelectorAll('[data-advisor-choice]').forEach((link) => {
          link.addEventListener('click', (event) => {
            const result = link.dataset.advisorChoice;
            if (!this.querySelector(`[data-result="${result}"]`)) return;
            event.preventDefault();
            this.showResult(result);
          });
        });

        this.querySelectorAll('[data-advisor-question]').forEach((link) => {
          link.addEventListener('click', (event) => {
            const group = link.dataset.advisorQuestion;
            if (!this.querySelector(`[data-question="${group}"]`)) return;
            event.preventDefault();
            this.currentResult = '';
            this.previousGroup = this.currentGroup;
            this.showQuestion(group);
          });
        });

        this.progressItems.forEach((item) => {
          item.addEventListener('click', () => {
            const target = item.dataset.advisorProgressTarget;
            if (target === 'start') this.showStart();
            if (target === 'choice' && this.currentGroup) this.showQuestion(this.currentGroup);
            if (target === 'result' && this.currentResult) this.showResult(this.currentResult);
          });
        });

        this.querySelectorAll('[data-advisor-back="start"]').forEach((link) => {
          link.addEventListener('click', (event) => {
            event.preventDefault();
            this.showStart();
          });
        });

        this.querySelectorAll('[data-advisor-back="previous"]').forEach((link) => {
          link.addEventListener('click', (event) => {
            event.preventDefault();
            if (this.previousGroup) {
              const targetGroup = this.previousGroup;
              this.previousGroup = '';
              this.showQuestion(targetGroup);
            } else {
              this.showStart();
            }
          });
        });

        this.querySelectorAll('[data-advisor-back="choice"]').forEach((link) => {
          link.addEventListener('click', (event) => {
            event.preventDefault();
            if (this.currentGroup) this.showQuestion(this.currentGroup);
            else this.showStart();
          });
        });

        this.querySelectorAll('[data-advisor-reset]').forEach((link) => {
          link.addEventListener('click', (event) => {
            event.preventDefault();
            this.resetAdvisor();
          });
        });

        const hashId = window.location.hash ? window.location.hash.slice(1) : '';
        const hashTarget = hashId ? document.getElementById(hashId) : null;
        if (hashTarget && this.contains(hashTarget)) {
          if (hashTarget.dataset.question) this.showQuestion(hashTarget.dataset.question, false);
          if (hashTarget.dataset.result) this.showResult(hashTarget.dataset.result, false);
        } else {
          this.updateProgress('start');
        }
      }

      hideStages() {
        if (this.startStage) this.startStage.hidden = true;
        this.questionStages.forEach((stage) => { stage.hidden = true; });
        this.resultStages.forEach((stage) => { stage.hidden = true; });
        this.querySelectorAll('[data-advisor-route], [data-advisor-choice], [data-advisor-question]').forEach((link) => {
          link.setAttribute('aria-expanded', 'false');
        });
      }

      showStart(move = true) {
        this.hideStages();
        if (this.startStage) {
          this.startStage.hidden = false;
          this.updateProgress('start');
          if (move) this.moveTo(this.startStage);
        }
      }

      showQuestion(group, move = true) {
        const stage = this.querySelector(`[data-question="${group}"]`);
        if (!stage) return;
        this.hideStages();
        this.currentGroup = group;
        stage.hidden = false;
        this.querySelectorAll(`[data-advisor-route="${group}"], [data-advisor-question="${group}"]`).forEach((link) => {
          link.setAttribute('aria-expanded', 'true');
        });
        this.updateProgress('choice');
        if (move) this.moveTo(stage);
      }

      showResult(result, move = true) {
        const stage = this.querySelector(`[data-result="${result}"]`);
        if (!stage) return;
        this.hideStages();
        this.currentResult = result;
        stage.hidden = false;
        this.querySelectorAll(`[data-advisor-choice="${result}"]`).forEach((link) => {
          link.setAttribute('aria-expanded', 'true');
        });
        this.updateProgress('result');
        if (move) this.moveTo(stage);
      }

      resetAdvisor(move = true) {
        this.currentGroup = '';
        this.previousGroup = '';
        this.currentResult = '';
        this.showStart(move);
      }

      updateProgress(active) {
        this.progressItems.forEach((item) => {
          const target = item.dataset.advisorProgressTarget;
          const isActive = item.dataset.progress === active;
          const canNavigate = !isActive && (
            target === 'start'
            || (target === 'choice' && this.currentGroup)
            || (target === 'result' && this.currentResult)
          );

          if (isActive) item.setAttribute('aria-current', 'step');
          else item.removeAttribute('aria-current');

          item.disabled = !canNavigate;
          item.classList.toggle('is-complete', Boolean(canNavigate));
        });
      }

      moveTo(stage) {
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.requestAnimationFrame(() => {
          stage.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
          const heading = stage.querySelector('h2');
          if (heading) {
            heading.setAttribute('tabindex', '-1');
            heading.focus({ preventScroll: true });
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
